import React from 'react';
import { Loader2, Shield } from 'lucide-react';

export function LoadingScreen() {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center gap-6 p-6">
      <div className="flex flex-col items-center gap-4">
        <div className="bg-primary text-primary-foreground flex size-12 items-center justify-center rounded-lg">
          <Shield className="size-7" />
        </div>
        <h1 className="text-2xl font-semibold">Vault Secret Manager</h1>
      </div>

      <div className="flex flex-col items-center gap-3">
        <Loader2 className="size-8 animate-spin text-muted-foreground" />
        <p className="text-muted-foreground text-sm">Checking authentication...</p>
      </div>
    </div>
  );
}
